import React, { useState } from "react";
import { ArrowRight } from "lucide-react";
import { catalogueItemKey, usePublicCatalog } from "../../api/catalogApi";

const OurServices = () => {
  const [visibleCount, setVisibleCount] = useState(4);
  const [hoveredCard, setHoveredCard] = useState(null);
  const { services, loading, error } = usePublicCatalog();

  return (
    <section
      style={{
        padding: "30px 20px",
        background: "#ffffff",
        fontFamily: "sans-serif",
      }}
    >
      <div style={{ maxWidth: "1400px", margin: "0 auto" }}>
        <div
          style={{
            textAlign: "center",
            maxWidth: "720px",
            margin: "0 auto 45px",
          }}
        >
          <h2
            style={{
              fontSize: "35px",
              fontWeight: "bold",
              color: "#bd06b3",
              textTransform: "uppercase",
              letterSpacing: "1px",
              margin: "8px 0 0",
            }}
          >
            Our Business <span style={{ color: "#00bfff" }}>Services</span>
          </h2>
          <p
            style={{
              margin: "16px auto 0",
              maxWidth: "620px",
              color: "#6b7280",
              fontSize: "14px",
              lineHeight: 1.7,
            }}
          >
            Explore services and offerings supplied by Iconic sister companies.
          </p>
        </div>

        {loading ? (
          <p role="status" style={{ textAlign: "center", color: "#64748b" }}>
            Loading catalogue…
          </p>
        ) : error ? (
          <p role="alert" style={{ textAlign: "center", color: "#b91c1c" }}>
            {error}
          </p>
        ) : services.length === 0 ? (
          <p style={{ textAlign: "center", color: "#64748b" }}>
            No services are currently available.
          </p>
        ) : (
          <>
            <div
              style={{
                display: "grid",
                gridTemplateColumns:
                  "repeat(auto-fit, minmax(min(100%, 300px), 1fr))",
                gap: "22px",
              }}
            >
              {services.slice(0, visibleCount).map((service) => {
                const key = catalogueItemKey(service);
                const isHovered = hoveredCard === key;
                const products = Array.isArray(service.products)
                  ? service.products
                  : [];

                return (
                  <article
                    key={key}
                    onMouseEnter={() => setHoveredCard(key)}
                    onMouseLeave={() => setHoveredCard(null)}
                    style={{
                      background: "#ffffff",
                      border: isHovered
                        ? "1px solid #bd06b3"
                        : "1px solid rgba(189, 6, 179, 0.15)",
                      borderRadius: "14px",
                      padding: "24px",
                      transition: "all 0.25s ease",
                      boxShadow: isHovered
                        ? "0 10px 25px rgba(189, 6, 179, 0.10)"
                        : "0 3px 12px rgba(189, 6, 179, 0.05)",
                      transform: isHovered ? "translateY(-4px)" : "translateY(0)",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "15px",
                        marginBottom: "20px",
                      }}
                    >
                      <div
                        aria-hidden="true"
                        style={{
                          width: "52px",
                          height: "52px",
                          minWidth: "52px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          borderRadius: "12px",
                          background: "rgba(189, 6, 179, 0.07)",
                          border: "1px solid rgba(189, 6, 179, 0.14)",
                          color: "#bd06b3",
                          fontSize: "22px",
                          fontWeight: 700,
                        }}
                      >
                        {service.company_name?.trim()?.charAt(0) || ""}
                      </div>
                      <span
                        style={{
                          padding: "6px 10px",
                          borderRadius: "20px",
                          background: "rgba(0, 191, 255, 0.07)",
                          border: "1px solid rgba(0, 191, 255, 0.16)",
                          color: "#00bfff",
                          fontSize: "10px",
                          fontWeight: 700,
                          letterSpacing: "0.5px",
                        }}
                      >
                        {service.company_name}
                      </span>
                    </div>

                    <h3
                      style={{
                        margin: "0 0 10px",
                        color: "#bd06b3",
                        fontSize: "19px",
                        fontWeight: 750,
                        lineHeight: 1.4,
                      }}
                    >
                      {service.name}
                    </h3>

                    {service.description && (
                      <p
                        style={{
                          margin: "0 0 22px",
                          color: "#64748b",
                          fontSize: "13px",
                          lineHeight: 1.7,
                        }}
                      >
                        {service.description}
                      </p>
                    )}

                    {products.length > 0 && (
                      <div>
                        <p
                          style={{
                            margin: "0 0 12px",
                            color: "#00bfff",
                            fontSize: "11px",
                            fontWeight: 700,
                            letterSpacing: "0.8px",
                            textTransform: "uppercase",
                          }}
                        >
                          Products and offerings
                        </p>
                        <ul
                          style={{
                            listStyle: "none",
                            padding: 0,
                            margin: 0,
                            display: "flex",
                            flexDirection: "column",
                            gap: "8px",
                          }}
                        >
                          {products.map((product) => (
                            <li
                              key={catalogueItemKey(product)}
                              style={{
                                display: "flex",
                                alignItems: "flex-start",
                                gap: "9px",
                                color: "#64748b",
                                fontSize: "13px",
                                lineHeight: 1.5,
                              }}
                            >
                              <span
                                aria-hidden="true"
                                style={{
                                  width: "5px",
                                  height: "5px",
                                  minWidth: "5px",
                                  marginTop: "6px",
                                  borderRadius: "50%",
                                  background: "#bd06b3",
                                }}
                              />
                              <span>{product.name}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </article>
                );
              })}
            </div>

            {services.length > 4 && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "40px",
                }}
              >
                <button
                  type="button"
                  onClick={() =>
                    setVisibleCount((count) =>
                      count < services.length ? count + 4 : 4,
                    )
                  }
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    padding: "11px 22px",
                    borderRadius: "8px",
                    border: "1px solid rgba(189, 6, 179, 0.25)",
                    background: "#ffffff",
                    color: "#bd06b3",
                    fontSize: "13px",
                    fontWeight: 700,
                    cursor: "pointer",
                  }}
                >
                  {visibleCount < services.length ? "Show More" : "Show Less"}
                  <ArrowRight
                    size={15}
                    style={{
                      transform:
                        visibleCount < services.length ? undefined : "rotate(-90deg)",
                    }}
                  />
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </section>
  );
};

export default OurServices;
